import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18next, { changeLanguage } from 'i18next';
import './LanguageScreen.scss';
import ConfirmationModal from '../../../app/components/ConfirmationModal';

function LanguageScreen() {
  const { t } = useTranslation();
  const languages: string[] = ['en', 'es'];
  const [showModal, setShowModal] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState<string | null>(null);

  useEffect(() => {
    const savedLanguage = localStorage.getItem('@language');
    changeLanguage(savedLanguage ?? 'en');
  }, []);

  const handleClick = (lng: string) => {
    if (lng !== i18next.language) {
      setSelectedLanguage(lng);
      setShowModal(true);
    }
  };

  const handleConfirmLanguageChange = () => {
    if (selectedLanguage) {
      changeLanguage(selectedLanguage);
      localStorage.setItem('@language', selectedLanguage);
      setShowModal(false);
    }
  };

  const handleCancelLanguageChange = () => {
    setShowModal(false);
    setSelectedLanguage(null);
  };

  const RenderCard: React.FC<{ item: string }> = ({ item }) => {
    const isActive = item === i18next.language;
    return (
      // eslint-disable-next-line
      <div
        className={`language-card ${isActive ? 'active' : ''}`}
        onClick={() => handleClick(item)}
      >
        <input className='form-check-input' type='radio' checked={isActive} onChange={() => {}} />
        <label className='form-check-label'>
          {item === 'en' ? 'English ' : 'Español '}
          <span className={`language-region ${isActive ? 'active' : ''}`}>
            {item === 'en' ? '(US)' : '(Latinoamérica)'}
          </span>
        </label>
      </div>
    );
  };

  const getConfirmButtonText = () => {
    if (selectedLanguage === 'en') {
      return t('Change to English');
    } else if (selectedLanguage === 'es') {
      return t('Change to Español');
    }
    return t('Change Language');
  };

  return (
    <div className='language-screen'>
      <h1>{t('Select Language')}</h1>
      {languages.map((item) => (
        <RenderCard key={item} item={item} />
      ))}
      <ConfirmationModal
        showModal={showModal}
        onHide={handleCancelLanguageChange}
        onConfirm={handleConfirmLanguageChange}
        title={t('Are you sure you want to change the language of Direct2Care?')}
        bodyText={t('')}
        confirmButtonText={getConfirmButtonText()}
        cancelButtonText={t('Cancel')}
        iconAlt={t('Language Icon')}
      />
    </div>
  );
}

export default LanguageScreen;
